module.exports = __webpack_public_path__ + "static/img/1-12.31844da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/1-12.png
// module id = MQi9
// module chunks = 0